import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import for React 18
import './index.css';
import App from './App';
import AOS from 'aos';
import 'aos/dist/aos.css';  // Import AOS CSS here, not in index.css

AOS.init();  // Initialize AOS

// React 18's new way of rendering
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
